import React from 'react';
import CommerceDocPublicPage from './CommerceDocPublicPage';

export default function InvoicePublic() {
  return <CommerceDocPublicPage mode="invoice" />;
}
